<template>
  <div class="card">
      <div class="card-image ">
        <router-link :to="'/videos/' + video.id">
        <figure class="image is-4by3">
          <img :src="video.thumbnail" alt="" />
        </figure>
        </router-link>
      </div>
      <div class="card-content">
        <span class="content has-text-centered">
          <h3>{{ video.title }}</h3>
        </span>
        <div class="tag-container">
          <div class="tags has-addons">
            <span class="tag">Content:</span>
            <span class="tag is-primary">{{ video.content_area }}</span>
          </div>
          <div class="tags has-addons">
            <span class="tag">Grade:</span>
            <span class="tag is-primary">{{ video.grade }}</span>
          </div>
        </div>
        <span v-for="tag in video.tags" class="tag is-primary has-text-centered cftag">{{ tag.text }}</span>
      </div>
      <footer class="card-footer">

        <a class="card-footer-item">
        <div class="editing-container">
          <input
            @click="removeVideoFromLibrary(libraryID, video.id)"
            v-if="editing"
            type='button'
            class='button is-danger'
            value='remove'
            name='remove'/>
          <input
            v-if="editing"
            @click="editing = false"
            type='button'
            class='button'
            value='cancel'
            name='cancel'/>
          <input
            v-if="!editing"
            @click="editing = !editing"
            type='button'
            class='button'
            value='edit'
            name='edit'/>
        </div></a>
      </footer>
    </div>
</template>


<script>
  import store from '../store.js'

  export default {
    name: 'LibraryVideo',
    data () {
      return { 'editing': false }
    },
    props: ['video', 'libraryID'],
    methods: {
      removeVideoFromLibrary (_, videoID) {
        store.dispatch('updateVideoLibrary', { videoID, libraryID: null })
        this.editing = false
      },
    },
  }
</script>


<style lang="scss" scoped>
  .card {
    width: 300px;
    margin: 20px;
    box-shadow: 0 16px 32px 0 rgba(62,57,107,0.2);
  }
  .cftag {
    background-color: #E8117F;
    margin: 0px 2px;
    border-radius: 6px;
  }

  .tag-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .tags > .tag {
    border-bottom: 1px solid lightgrey;
  }
  .tags > .tag.is-primary {
    border-bottom: 1px solid darken(#23c6c8, 5%);
  }

</style>

<style lang="sass" scoped>
.tags
  align-items: center
  display: flex
  justify-content: flex-start
  .tag
    border-radius: 3px
    margin-bottom: .5rem
    &:not(:last-child)
      margin-right: 0.5rem
  &.has-addons
    .tag
      // box-shadow: 0 2px 3px 0 rgba(62,57,107,0.2)
      margin-right: 0
      &:not(:first-child)
        border-bottom-left-radius: 0
        border-top-left-radius: 0
      &:not(:last-child)
        border-bottom-right-radius: 0
        border-top-right-radius: 0

</style>



// WEBPACK FOOTER //
// LibraryVideo.vue?0af6e2f4